import * as yup from 'yup';

export enum RegionEnum {
  none = '',
  northAmerica = 'North America',
  southAmerica = 'South America',
  europe = 'Europe',
}

// Base Ranch Schema is the minimum fields required to create a new ranch
export const BaseRanchSchema = yup.object().shape({
  customerID: yup.string().required('Customer ID is required'),
  name: yup.string().required('Name is required'),
  region: yup
    .string()
    .oneOf(Object.values(RegionEnum), 'Invalid region')
    .required('Region is required'),
});

export type BaseRanch = yup.InferType<typeof BaseRanchSchema>;

export const RanchSchema = BaseRanchSchema.shape({
  id: yup.string().required('ID is required'),
  fromDate: yup.string().nullable(),
  thruDate: yup.string().nullable(),
});

export type Ranch = yup.InferType<typeof RanchSchema>;
